// extracted by mini-css-extract-plugin
export default {"wrapper":"carInputCreate_wrapper__5ka-2","customInput":"carInputCreate_customInput__STKPw"};